module.exports = __webpack_public_path__ + "img/Pay ratio.e0c0e811.png";